module.exports = __webpack_public_path__ + "img/bqGZHimg.cc1d5479.png";